import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const GraphpadIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Y-axis */}
      <line x1="4" y1="2" x2="4" y2="20" />
      {/* X-axis */}
      <line x1="4" y1="20" x2="22" y2="20" />
      {/* Curve representing a function */}
      <path d="M4 16 C8 16, 10 4, 20 4" />
    </svg>
  );
});

GraphpadIcon.displayName = 'GraphpadIcon';
